/* eslint-disable react/prop-types */
/* eslint-disable max-len */

/* eslint-disable react/react-in-jsx-scope */
import
React,
{ useMemo } from 'react';
import { Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';

const reviewDetail = (history, info) => {
  history.push({
    pathname: `/admin/review-detail/${info.id}`,
    state: { data: info },
  });
};

const ListDataReview = (dataAPI) => {
  const history = useHistory();
  const columns = useMemo(
    () => [
      {
        Header: 'No',
        accessor: 'number',
        width: 20,
        disableGlobalFilter: true,
        disableSortBy: true,
      },
      {
        Header: 'Date',
        accessor: 'created_at',
        width: 20,
        disableGlobalFilter: true,
        disableSortBy: true,
      },
      {
        Header: 'Reviewer',
        accessor: 'reviewer',
        width: 110,
      },
      {
        Header: 'Course',
        accessor: 'course',
        width: 110,
      },
      {
        Header: 'Rate',
        accessor: 'rate',
        width: 110,
      },
      {
        Header: 'Headline',
        accessor: 'headline',
        width: 110,
      },
      {
        Header: 'Comment',
        accessor: 'comment',
        width: 110,
        Cell: ({ value }) => (
          <span>{value.length > 150 ? `${value.substring(0, 150)}...` : value}</span>
        ),
      },
      {
        Header: 'Action',
        accessor: 'action',
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 110,
      },
    ], [],
  );

  const data = [];
  const rows = () => {
    for (let i = 0; i < dataAPI.length; i += 1) {
      data.push({
        id: dataAPI[i].id,
        number: `${i + 1}`,
        created_at: dataAPI[i]?.created_at,
        reviewer: dataAPI[i]?.user_detail?.name,
        course: dataAPI[i]?.course_detail?.title,
        rate: `${dataAPI[i]?.rate}`,
        headline: dataAPI[i]?.headline,
        comment: dataAPI[i]?.comment,
        action: [
          // eslint-disable-next-line no-loop-func
          // eslint-disable-next-line max-len
          (<Button key={dataAPI[i].id} color="outline-success" onClick={() => reviewDetail(history, dataAPI[i])}>Detail</Button>),
        ],
      });
    }
  };

  rows();
  const partnerListTableData = { tableHeaderData: columns, tableRowsData: data };
  return partnerListTableData;
};

export default ListDataReview;
